import { render, staticRenderFns } from "./StationModal.vue?vue&type=template&id=22cdaeef"
import script from "./StationModal.vue?vue&type=script&lang=js"
export * from "./StationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22cdaeef')) {
      api.createRecord('22cdaeef', component.options)
    } else {
      api.reload('22cdaeef', component.options)
    }
    module.hot.accept("./StationModal.vue?vue&type=template&id=22cdaeef", function () {
      api.rerender('22cdaeef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/print/StationModal.vue"
export default component.exports